import React, {Component, PropTypes} from 'react'
import {findDOMNode} from 'react-dom'
import {connect} from 'react-redux'
import {Row, Col, Nav, NavItem, Button, PageHeader, Popover, Tooltip, Overlay, OverlayTrigger} from 'react-bootstrap'
import {push} from '../../core/redux/router'
import {linkFinder} from '../../core/links'
import Icon from '../../core/components/Icon'
import DownloadIcon from '../../core/components/DownloadIcon'
import {PDF_TICKETS_REPORTED} from '../../ticket/actions'
import ReportTicketsModal from '../../ticket/components/ReportTicketsModal'
import ReferencePatrimonyPopover from '../../patrimony/components/ReferencePatrimonyPopover'
import i18n from '../i18n'
import UpdateAgencyPopover from './UpdateAgencyPopover'
import DeleteAgencyModal from './DeleteAgencyModal'
import style from './AgencyDetail.less'

function toLink(path) {
    return {
        active: path === '' ? location.pathname.split('/').length === 5 : location.pathname.endsWith(path),
        href: '/' + location.pathname.split('/').slice(1,5).join('/') + path
    }
}

function modalName(result) {
    switch (result) {
        case 'DELETE':
            return 'DeleteAgencyModal'
        default:
            return null
    }
}

class AgencyDetail extends Component {
    static propTypes = {
    }

    constructor(props) {
        super(props)

        this.state = {
        }
    }

    _openPopover(event, name) {
        event.preventDefault()
        this.setState({openedPopover: name})
    }

    _closePopover(event, result) {
        if (event) {
            event.preventDefault()
        }
        
        const openedPopover = null
        const openedModal = modalName(result)
        this.setState({openedPopover, openedModal})
    }

    _openModal(name) {
        this.setState({openedModal: name})
    }

    _closeModal(event) {
        if (event) {
            event.preventDefault()
        }
        
        this.setState({openedModal: null})
    }

    render() {
        const {children, dispatch, location, progress, authenticated, agency, _appLinks, _patrimonyLinks} = this.props
        const {openedPopover, openedModal} = this.state
        const {editButton, editContainer} = this.refs

        const editMenuPopover = (
            <Popover>
                <ul className={style.menu}>
                    {_patrimonyLinks.find(linkFinder('ReferencePatrimony')) && (
                        <li>
                            <a
                                href=''
                                onClick={(e) => this._openPopover(e, 'ReferencePatrimonyPopover')}>
                                <Icon icon='plus' size='xs' />
                                <span> {i18n.patrimony}</span>
                            </a>
                        </li>
                    )}
                    {agency._links.find(linkFinder('UpdateAgency')) && (
                        <li>
                            <a
                                href=''
                                onClick={(e) => this._openPopover(e, 'UpdateAgencyPopover')}>
                                <span>> {i18n.change}</span>
                            </a>
                        </li>
                    )}
                </ul>
            </Popover>
        )

        const editOverlay = (name, popover) => (
            <Overlay rootClose
                target={() => findDOMNode(editButton)}
                placement='bottom'
                show={openedPopover == name}
                container={editContainer}
                onHide={(e) => this._closePopover(e)}>
                {popover}
            </Overlay>
        )

        const tooltip = (text, status) => {
            return (
                <Tooltip className={status && 'tooltip-' + status}>
                    {text}
                </Tooltip>
            )
        }
        
        return (
            <div className={style.default}>
                <div className={style.defaultContent}>
                    <PageHeader className='large'>
                        <div
                            ref='editContainer'
                            className={style.header}>
                            <span>{i18n.agency} {agency.label}</span>
                            <div className={style.report}>
                                <div className={style.container}>
                                    <OverlayTrigger
                                        placement='bottom'
                                        overlay={tooltip(progress[PDF_TICKETS_REPORTED] && i18n.reportingAgency || i18n.reportPdfAgency, 'primary')}>
                                        <Button
                                            bsStyle='link'
                                            bsSize='small'
                                            disabled={!!progress[PDF_TICKETS_REPORTED]}
                                            onClick={() => this._openModal('ReportTicketsModal')}>
                                            <DownloadIcon progress={progress[PDF_TICKETS_REPORTED]} />
                                        </Button>
                                    </OverlayTrigger>
                                </div>
                            </div>
                            <a
                                className={style.edit}
                                ref='editButton'
                                href=''
                                onClick={(e) => this._openPopover(e, 'EditMenuPopover')}
                                onMouseOver={(e) => this._openPopover(e, 'EditMenuPopover')}>
                                <Icon
                                    icon='gear'
                                    size='xs'
                                    active={openedPopover != null} />
                            </a>
                        </div>
                        {editOverlay('EditMenuPopover', editMenuPopover)}
                        {_patrimonyLinks.find(linkFinder('ReferencePatrimony')) && editOverlay('ReferencePatrimonyPopover', (
                            <ReferencePatrimonyPopover
                                user={authenticated}
                                agency={agency}
                                onHide={(e) => this._closePopover(e)} />
                        ))}
                        {agency._links.find(linkFinder('UpdateAgency')) && editOverlay('UpdateAgencyPopover', (
                            <UpdateAgencyPopover
                                onHide={(e, r) => this._closePopover(e, r)} />
                        ))}
                    </PageHeader>
                    <Row>
                        <Col sm={4} smOffset={4}>
                        </Col>
                    </Row>
                    <Nav justified
                        bsStyle='list'>
                        <NavItem {...toLink('')}>
                            {i18n.synthesis}
                        </NavItem>
                        {_appLinks.find(linkFinder('tickets')) && (
                            <NavItem {...toLink('/tickets')}>
                                {i18n.tickets}
                            </NavItem>
                        )}
                        <NavItem disabled>
                            {i18n.patrimony}
                        </NavItem>
                        <NavItem {...toLink('/documents')}>
                            {i18n.documents}
                        </NavItem>
                        {_appLinks.find(linkFinder('providercontacts')) && (
                            <NavItem {...toLink('/providercontacts')}>
                                {i18n.providers}
                            </NavItem>
                        )}
                    </Nav>
                    {agency._links.find(linkFinder('DeleteAgency')) && (
                        <DeleteAgencyModal
                            show={openedModal == 'DeleteAgencyModal'}
                            onHide={() => this._closeModal()} />
                    )}
                </div>
                {children}
                <ReportTicketsModal
                    agency={agency}
                    show={openedModal == 'ReportTicketsModal'}
                    onHide={() => this._closeModal()} />
            </div>
        )
    }
}

AgencyDetail = connect((state) => ({
    location: state.router.location,
    progress: state.progress,
    authenticated: state.user.authenticated,
    agency: state.company.agency.agency,
    _appLinks: state.app._links,
    _patrimonyLinks: state.patrimony._links
}))(AgencyDetail)

export default AgencyDetail


// WEBPACK FOOTER //
// ./lib/company/components/AgencyDetail.js